import React from "react";
import './Loading.css';

const Loading = ({loadingText="Loading..."}) => {
  return (
      <div className="proskins-loading-container">
        <div className="proskins-loading-spinner"></div>
        {loadingText !== "" && (
          <div className="proskins-loading-text">{loadingText}</div>
        )}
      </div>
  );
};

export default Loading;